import './menu_nav_item.css';

export const MenuNavItem = ({section}) => {
    //FUNCTIONS
    const select = () => {
        const element = document.querySelector('#menu_section_' + section.id);
        if (element)
        {
            element.scrollIntoView({ behavior: "smooth" });
            
        }
    }

    return (
        <>
            {
                section.products && section.products.length > 0 && (
                    <button className={false ? 'menu_nav_item active' : 'menu_nav_item'} onClick={select}>
                        { section.name }
                    </button>
                )
            }
        </>
        
    );
}